import { Flex, Skeleton } from '@iheartjane/reefer';

import styles from './categorySelector.module.css';

export function CategorySelectorSkeleton() {
  return (
    <div className={styles['categorySelector']}>
      {Array(10)
        .fill(0)
        .map((_, i) => (
          <Skeleton key={i} animate>
            <Flex gap={8} flexDirection="column" alignItems="center">
              <Skeleton.Bone height={40} width={40} borderRadius="circular" />
              <Skeleton.Bone height={20} width={64} />
            </Flex>
          </Skeleton>
        ))}
    </div>
  );
}
